import uuid from 'react-uuid'

const initialState = {
  session_id: uuid(),
}
export default initialState
